import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Shipper } from '../../../models/shipper.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from '../../../services/app.service';
import { ShipperService } from '../../../services/shipper.service';
import { MasterService } from '../../../services/master.service';
import { Subject } from 'rxjs';
import { AjaxService } from '../../../../../core/services/ajax.service';
import { Http } from '@angular/http';
import { takeUntil } from 'rxjs/operators';
import { SystemDataService } from '../../../services/systemdata.service';
import { zMultiUserHandler } from '../../../models/user.model';

@Component({
    selector: 'app-shipper-edit-form',
    templateUrl: './shipper-edit-form.component.html',
    styleUrls: ['./shipper-edit-form.component.scss']
})
export class ShipperEditFormComponent implements OnInit {
    @Output() closeDialogue = new EventEmitter();
countryList: any = [];
countryFilterCtrl: FormControl = new FormControl();
/** Subject that emits when the component has been destroyed. */
private _onDestroy = new Subject<void>();
searchFlag: boolean = true;
cityList: any = [];
cityFilterCtrl: FormControl = new FormControl();
postalCodeList: any = [];
psFilterCtrl : FormControl = new FormControl();
shipperId : Number = 0;
formGroup: FormGroup;
formGroupErrors: any;
shipper = new Shipper();
loadingIndicator = false;
reorderable = true;
translations: any;
countryLoad = true;
cityLoad = true;
loadingCountry = false;
invalidForm = true;

countryRequired = false;
cityRequired = false;
pcRequired = false;

multiUserHandler = new zMultiUserHandler();

constructor( @Inject(MAT_DIALOG_DATA)
            public data: { Id : 0 },
            public dialog: MatDialog,
            private formBuilder: FormBuilder,
            public appService: AppService,
            private shipperService: ShipperService,
            private masterService: MasterService,
            private http: Http,
            private _ajaxService: AjaxService,
            public dialogRef: MatDialogRef<ShipperEditFormComponent>,
            public systemDataService: SystemDataService){
    this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
        Code :{},
        Name: {},
        IsActive: {},
        Email: {},
        Address :{},
        VAT:{},
        DeliveryCondition:{}
    };

    this.formGroup = this.formBuilder.group({
        Code:['',Validators.required],
        Name: ['', Validators.required] ,
        IsActive: ['', Validators.required],
        //Email: ['', Validators.pattern(/^(([a-zA-Z0-9_\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))*$/)],
        // Email: ['', Validators.pattern(/^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/)],
        // Email: ["", Validators.pattern(/^([\w-\.]{1,64}((\[|\()?@(\]|\))?|(\[|\()?at(\]|\))?|(\[|\()?kukac(\]|\))?)[\w-]{1,64}((\[|\()?\.(\]|\))?|(\[|\()?dot(\]|\))?|(\[|\()?pont(\]|\))?)[a-zA-Z]{2,3})$/)],
        Email: ['', [Validators.pattern(/^([\w+-.%]+@[\w\-.]+\.[A-Za-z]{2,4};?)+$/)]],
        Address:['',Validators.required],
        VAT:['',Validators.required],
        DeliveryCondition:['',Validators.required]
    });
    this.shipperId = this.data.Id;
}
onCountryBlur(e){
    this.countryRequired = this.shipper.CountryId > 0 ? false : true;
}
onCityBlur(e){
    this.cityRequired = this.shipper.CityId > 0 ? false : true;
}
onPCBlur(e){
    this.pcRequired = this.shipper.PostalCodeId > 0 ? false : true;
}
ngOnInit() {
    this.countryLoad = true;
    this.cityLoad = true;
    this.formGroup.valueChanges.subscribe(() => {
        this.formGroupErrors = this.appService.onFormValuesChanged(      
            this.formGroup,
            this.formGroupErrors
        );
        if(this.shipper.CountryId > 0
           && this.shipper.CityId > 0
           && this.shipper.PostalCodeId > 0
           && !this.formGroup.invalid){
            this.invalidForm = false;
        }
        else{
            this.invalidForm = true;
        }

    });

    if (this.shipperId > 0) {
        this.selectShipperById();
    }
    else{
        this.appService.hideLoading();
        this.invalidForm = true;
    }
    this.countryFilterCtrl.valueChanges
        .debounceTime(400)
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
        this.filterCountry();
    });
    this.cityFilterCtrl.valueChanges
        .debounceTime(400)
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
        this.filterCity();
    });
    this.psFilterCtrl.valueChanges
        .debounceTime(400)
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
        this.filterPostalCode();
    });
}



setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
}

selectShipperById(): void{
    this.shipperService.select(this.shipperId).subscribe(
    res => this.getShipperDetailsSuccess(res),
    error => this.apiFaillure(error)
    );
}

getShipperDetailsSuccess(res): void{
    this.appService.hideLoading();
    if(res.Data != null){
    this.shipper = JSON.parse(res.Data)[0]; 
    this.countryFilterCtrl.setValue(this.shipper["Country"]);
    this.cityFilterCtrl.setValue(this.shipper["City"]);
    this.psFilterCtrl.setValue(this.shipper["PostalCode"]);
    this.invalidForm = false;       
}
else{
    this.apiFaillure(res.Message);
}
}

filterCountry() {
    this.loadingCountry = true;
    let search = this.countryFilterCtrl.value;
    if (search && search.length > 0) {
        this._ajaxService
            .GET(
            "Master.svc/master/31/" +
            (typeof this.shipper.CountryId != "undefined"
             ? this.shipper.CountryId
             : 0) +
            "/0/" +
            (!search ? " " : search) +
            "/0"
        )
            .subscribe(response => {
            this.countryList = JSON.parse(response.Data);
            this.countryRequired = this.shipper.CountryId > 0 ? false : true;
        });
    } else {
        this.shipper.CountryId = 0;
        this.countryList = [];
        this.countryRequired = true;
    }
}
onCountrySelect(countryId) {
    if (this.shipper.CountryId != countryId) {
        this.invalidForm = true;
        this.shipper.CountryId = countryId;
        this.countryRequired = this.shipper.CountryId > 0 ? false : true;
        this.shipper.CityId = 0;
        this.cityFilterCtrl.setValue("");
        this.shipper.PostalCodeId = 0;
        this.psFilterCtrl.setValue("");
    }
}
onCitySelect(cityId) {
    if (this.shipper.CityId != cityId) {
        this.invalidForm = true;
        this.shipper.CityId = cityId;
        this.cityRequired = this.shipper.CityId > 0 ? false : true;
        this.shipper.PostalCodeId = 0;
        this.psFilterCtrl.setValue("");
    }
}
onPCSelect(pcId) {
    if (this.shipper.PostalCodeId != pcId) {
        this.shipper.PostalCodeId = pcId;
        this.pcRequired = this.shipper.PostalCodeId > 0 ? false : true;
        if(this.shipper.CountryId > 0
           && this.shipper.CityId > 0
           && this.shipper.PostalCodeId > 0
           && !this.formGroup.invalid){
            this.invalidForm = false;
        }
        else{
            this.invalidForm = true;
        }
    }
}
filterCity() {

    let search = this.cityFilterCtrl.value;

    if (
        search &&
        search.length > 0 &&
        typeof this.shipper.CountryId != "undefined" &&
        this.shipper.CountryId > 0
    ) {
        this._ajaxService
            .GET(
            "Master.svc/master/33/" +
            (typeof this.shipper.CityId != "undefined"
             ? this.shipper.CityId
             : 0) +
            "/" +
            (typeof this.shipper.CountryId != "undefined"
             ? this.shipper.CountryId
             : 0) +
            "/" +
            (!search ? " " : search) +
            "/0"
        )
            .subscribe(response => {
            this.cityList = JSON.parse(response.Data);
        });
    } else {
        this.shipper.CityId = 0;
        this.cityList = [];
        this.cityRequired = true;
    }
}
filterPostalCode() {
    let search = this.psFilterCtrl.value;

    if (
        search &&
        search.length > 0 &&
        typeof this.shipper.CityId != "undefined" &&
        this.shipper.CityId > 0
    ) {
        this._ajaxService
            .GET(
            "Master.svc/master/34/" +
            (typeof this.shipper.PostalCodeId != "undefined"
             ? this.shipper.PostalCodeId
             : 0) +
            "/" +
            (typeof this.shipper.CityId != "undefined"
             ? this.shipper.CityId
             : 0) +
            "/" +
            (!search ? " " : search) +
            "/0"
        )
            .subscribe(response => {
            this.postalCodeList = JSON.parse(response.Data);
        });
    } else {
        this.shipper.PostalCodeId = 0;
        this.postalCodeList = [];
        this.pcRequired = true;
    }
}
apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
}

save(): void{
    this.appService.showLoading();
    if(this.shipperId > 0){
    this.multiUserHandler.RecordId = this.shipperId;
    this.multiUserHandler.TableName = "mShipper";
    this.systemDataService.multiuserhandler(JSON.stringify(this.multiUserHandler)).subscribe(
    res => this.multiUserHandlerSuccess(res),
    error => this.apiFaillure(error)
    );
}
else{
    this.saveShipperData();
}
}
saveShipperSuccess(res): void{
    this.appService.hideLoading();
    if (res.Status == 1) {
    this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message])
    .afterClosed().subscribe(result => {
    if (result) {
    this.close();
}          
});    
} else if (res.Status == -1) {
    this.apiFaillure(res.Message);
}
}

multiUserHandlerSuccess(res){
    if(res.Status == 1){
        this.appService.showDialogue(this.translations.hdInfo, this.translations.msgOverwriteExistingDetails,true)
        .afterClosed().subscribe(result => {
            if(result){
                this.saveShipperData();
            }
            else{
                this.close();
            }
        });
    }
    else{
        this.saveShipperData();
    }
}

saveShipperData(){
    this.shipperService.save(JSON.stringify(this.shipper)).subscribe(
        res => this.saveShipperSuccess(res),
        error => this.apiFaillure(error)
    );
}

close(){
    this.dialogRef.close();
}


}




// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/shipper/shipper-edit-form/shipper-edit-form.component.ts